import { email } from 'vuelidate/lib/validators'

/**
 * Validates an email address against format definitions
 */
const validateEmail = function (emailAddress) {
  var isEmail = email(emailAddress)
  var regexMinimumCharsBeforeAt = /.{3,}@.*/
  return isEmail && regexMinimumCharsBeforeAt.test(emailAddress)
}

export default {
  methods: {
    validateEmail
  }
}
